/** Name of the hidden field carrying the form's Sanity "Form ID" on submit;
 *  the send-form route reads it to resolve the form title. */
export const FORM_ID_FIELD = '_formId';

/**
 * Name of the hidden field carrying the locale the form was rendered in.
 *
 * `form` is a translated document type, so the same "Form ID" slug exists once
 * per language — without the locale the route could not tell the German form
 * from its English translation. It also picks the language of the notification
 * mail's subject.
 */
export const FORM_LOCALE_FIELD = '_formLocale';

export type FormDto = {
    id: string;
    title?: string;
    fields?: FormFieldDto[];
    submitButton?: {
        text?: string;
    };
};

export type FormFieldDto = {
    _key?: string;
    label?: string;
    name?: string;
    required?: boolean;
    type?:
        | 'checkbox'
        | 'color'
        | 'date'
        | 'datetime-local'
        | 'email'
        | 'file'
        | 'hidden'
        | 'number'
        | 'radio'
        | 'range'
        | 'select'
        | 'tel'
        | 'text'
        | 'textarea'
        | 'time'
        | 'url';
    validation?: {
        type?: string;
        value?: string;
        message?: string;
    }[];
    choices?: {
        label?: string;
        value?: string;
    }[];
    options?: {
        placeholder?: string;
        defaultValue?: string;
    };
};
